// @ts-check
import get from 'lodash/get';
import createFacet from './createFacet';

/**
 * @param {import('./createFacet').CreateFacetOptions &
 *  { itemKey: string | ((any) => any) }} options
 */
export default function createNumericRangeFacet(options) {
  const { stateKey, itemKey } = options;
  return createFacet(
    {
      // The initial value for the reducer.
      // If a filter is set on the keys: keep that value in the facets even with 0 results.
      initialValue: [undefined, undefined],
      // state and prepare are defined in createFacet.

      // We don't have facets for basic numeric values, so we don't need to define a reducer.
      // reducer: (facetValues) => facetValues,

      // Tests if an item matches a certain filter. The values are in the format [min, max].
      /**
       * @param {{[stateKey]: [min: number, max: number], [x: string]: any}} filterValues
       */
      matches: ({ [stateKey]: filterValues }) => {
        if (filterValues?.length !== 2) return () => true;
        const min = toNumber(filterValues[0]);
        const max = toNumber(filterValues[1]);
        return (item) => {
          const value = getExt(item, itemKey);
          const numericValue = toNumber('' + value);
          if (min != null) {
            if (numericValue == null) return false;
            if (numericValue < min) return false;
          }
          if (max != null) {
            if (numericValue == null) return false;
            if (numericValue > max) return false;
          }
          return true;
        };
      },
    },

    options
  );
}

function toNumber(val) {
  if (val == null) return undefined;
  if (typeof val === 'number') return val;
  if (typeof val !== 'string') return undefined;
  const num = parseFloat(val);
  if (Number.isNaN(num)) return undefined;
  return num;
}

function getExt(item, key, defaultValue) {
  if (typeof key === 'function') return key(item);
  return get(item, key, defaultValue);
}
